import React from 'react';
import { InstalledAppLinkCard } from '../InstalledAppLinkCard';
import { InstalledAppManagerCard } from '../InstalledAppManagerCard';
import { APP_LINK, APP_MANAGER } from './types';

export const installedAppCardSwitch = app =>
  ({
    [APP_MANAGER]: (
      <InstalledAppManagerCard key={app.id} description={app.description} appLogo={app.meta.logo} />
    ),
    [APP_LINK]: (
      <InstalledAppLinkCard
        key={app.id}
        appLogo={app.meta.logo}
        appLink={app.meta.link}
        description={app.description}
      />
    ),
  }[app.type]);

export default installedAppCardSwitch;
